import type { RouteLocationNormalizedGeneric } from 'vue-router';

type Tile = {
  category_plps: Array<string>;
  search_plps: Array<string>;
  page_urls: Array<{ url: string }>;
  text_overlay_style: string;
  recos: Array<string>;
  add_personalization: { add_personalization: Array<string> };
  segment_id: { segment_id: string };
};

const filterBySearch = (tiles?: Array<Tile>, searchTerms?: string) => {
  if (!Array.isArray(tiles) || !searchTerms) {
    return [];
  }

  const searchTermsLower = searchTerms.toLowerCase();

  return tiles.filter((tile) => {
    if (!tile.search_plps?.length) {
      return false;
    }

    return tile.search_plps.find((searchPlp) => {
      return searchTermsLower.includes(searchPlp.toLowerCase());
    });
  });
};

const filterByPageUrl = (tiles: Array<Tile>, route: RouteLocationNormalizedGeneric) => {
  if (!Array.isArray(tiles)) {
    return [];
  }

  return tiles.filter((tile) => {
    if (!Array.isArray(tile.page_urls)) {
      return false;
    }

    return tile.page_urls.find((page) => page.url === route?.path);
  });
};

const filterByCategory = (tiles: Array<Tile>, pageCategories: Array<string>) => {
  if (!Array.isArray(tiles) || !Array.isArray(pageCategories)) {
    return [];
  }

  return tiles.filter((tile) => {
    if (!Array.isArray(tile.category_plps)) {
      return false;
    }

    return tile.category_plps.find((category) => pageCategories.includes(category));
  });
};

const filterByReco = (tiles: Array<Tile>, recoName: string) => {
  if (!Array.isArray(tiles) || !recoName) {
    return [];
  }

  return tiles.filter((tile) => {
    return tile.text_overlay_style === 'no-text' && tile.recos?.length && tile.recos.includes(recoName);
  });
};

const getContentTileToDisplay = (tiles: Array<PersonalizationPropsLegacy>) => {
  const personalizedTile = tiles.find((tile) => {
    if (typeof tile.add_personalization === 'object' && 'add_personalization' in tile.add_personalization) {
      return tile?.add_personalization?.add_personalization?.length;
    }

    return null;
  });

  if (personalizedTile) {
    return personalizedTile;
  }

  return tiles.at(0);
};

export const getProductListingContentTiles = (
  tiles: Array<Tile>,
  segments: Array<string>,
  route: RouteLocationNormalizedGeneric,
  pageCategories: string[],
) => {
  let filteredTiles = filterByPageUrl(tiles, route);

  if (!filteredTiles?.length) {
    filteredTiles = filterByCategory(tiles, pageCategories);
  }

  return getCmsPersonalizedContent(segments, filteredTiles);
};

export const getProductSearchContentTiles = (tiles: Array<Tile>, segmentsString: string, searchTerms: string) => {
  const filteredTiles = filterBySearch(tiles, searchTerms);
  return getCmsPersonalizedContent(segmentsString, filteredTiles);
};

export const getRecoSliderContentTile = (tiles: Array<Tile>, segmentsString: string, recoName: string) => {
  const filteredTiles = filterByReco(tiles, recoName);
  return getContentTileToDisplay(getCmsPersonalizedContent(segmentsString, filteredTiles));
};
